// extracted by mini-css-extract-plugin
module.exports = {"collectionList":"CollectionList_collectionList__uBUCu"};